import { render, staticRenderFns } from "./FaceSagging.vue?vue&type=template&id=7a4359df"
import script from "./FaceSagging.vue?vue&type=script&lang=js"
export * from "./FaceSagging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports